import apiClient from "../api/apiClient"
import { AdvanceTaxReport, ArAgingReport, BalanceSheetReport, PnlReport, ReportParams, SalesTaxReport } from "../../types"

export const reportService = {
  async getAdvanceTaxReport(params: ReportParams): Promise<AdvanceTaxReport> {
    const response = await apiClient.get<{
      success: boolean
      data: AdvanceTaxReport
    }>("/admin/reports/advance-tax", { params })
    return response.data.data
  },

  downloadReport(url: string) {
    window.open(url, '_blank')
  },

  async generateExcelReport(startDate: string, endDate: string): Promise<AdvanceTaxReport> {
    return this.getAdvanceTaxReport({ startDate, endDate, format: 'excel' })
  },

  async getPnlReport(params: ReportParams): Promise<PnlReport> {
    const response = await apiClient.get<{
      success: boolean
      data: PnlReport
    }>("/admin/reports/pnl", { params })
    return response.data.data
  },

  async generatePnlExcel(startDate: string, endDate: string): Promise<PnlReport> {
    return this.getPnlReport({ startDate, endDate, format: 'excel' })
  },

  async getArAgingReport(params: { asOfDate: string; format?: 'json' | 'excel' }): Promise<ArAgingReport> {
    const response = await apiClient.get<{ success: boolean; data: ArAgingReport }>(
      '/admin/reports/ar-aging', { params }
    )
    return response.data.data
  },

  async generateArAgingExcel(asOfDate: string): Promise<ArAgingReport> {
    return this.getArAgingReport({ asOfDate, format: 'excel' })
  },

  async getBalanceSheetReport(params: { asOfDate: string; format?: 'json' | 'excel' }): Promise<BalanceSheetReport> {
    const response = await apiClient.get<{ success: boolean; data: BalanceSheetReport }>(
      '/admin/reports/balance-sheet', { params }
    )
    return response.data.data
  },

  async generateBalanceSheetExcel(asOfDate: string): Promise<BalanceSheetReport> {
    return this.getBalanceSheetReport({ asOfDate, format: 'excel' })
  },
  
  async getSalesTaxReport(params: ReportParams): Promise<SalesTaxReport> {
    const response = await apiClient.get<{
      success: boolean
      data: SalesTaxReport
    }>("/admin/reports/sales-tax", { params })
    return response.data.data
  },

  async generateSalesTaxExcel(startDate: string, endDate: string): Promise<SalesTaxReport> {
    return this.getSalesTaxReport({ startDate, endDate, format: 'excel' })
  },
}
